module.exports = __webpack_public_path__ + "img/d4.da1bf497.png";